module.exports = __webpack_public_path__ + "img/60x32x72-Kit.9d1db7b5.png";